exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.demo-dynamic[data-v-3bc59ba5]{\n  background-color: #f6f6f6;\n  padding: 15px;\n}\n", ""]);

// exports
